export default {
  label: {
    blockchain: 'Chuỗi khối',
    wallet: 'Cái ví',
    agentNo: 'Mã đại lý',
    usdtAmount: 'Số tiền USDT',
    usdtFee: 'Chi phí USDT',
    modify: 'Cập nhật thông tin tài khoản',
    delete: 'Xóa tài khoản này',
    withdrawCount: 'Số lần rút tiền',
    submitAmount: 'Gửi số tiền USDT',
    submitVndAmount: 'Nộp số tiền VNĐ',
    successAmount: 'Số tiền thành công',
    exchangeRate: 'tỷ giá',
    copy: 'sao chép'
  },
  rules: {
    blockchain: 'Chuỗi khối bot có thể trống không.',
    wallet: 'Cái ví bot có thể trống không.',
    type: 'Số tiền rút phải ở dạng kỹ thuật số.',
    min: 'Số tiền rút phải lớn hơn 100',
    max: 'Số tiền rút không được lớn hơn số dư.'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/usdt.js